import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import veritis_img from "../assets/images/veritis-logo.svg";
import veritis_banner from "../assets/images/veritis-banner.webp";
import { Button, Container, Col, Form, Row, Offcanvas, Badge } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import { FaStar, FaRegStar } from "react-icons/fa";
import { Link } from 'react-router-dom';



const CompanyProfile = () => {
  const [activeSection, setActiveSection] = useState("");

  const [expanded, setExpanded] = useState(null);
  const [newComments, setNewComments] = useState({});

  const announcements = [
    {
      id: 1,
      title: "New Office Launch 🎉",
      date: "March 10, 2024",
      description:
        "We are excited to announce the opening of our new office in New York!",
      likes: 24,
      comments: [
        { user: "Tecol Group", text: "Amazing! Looking forward to visiting." },
        { user: "Telsa Inc", text: "Great news, congratulations!" },
      ],
    },
    {
      id: 2,
      title: "Annual Meetup 2024 📅",
      date: "February 28, 2024",
      description: "Join us for our annual company meetup. Register now!",
      likes: 18,
      comments: [{ user: "Emma", text: "Can't wait for the event!" }],
    },
    {
      id: 3,
      title: "Product Update 🚀",
      date: "February 15, 2024",
      description: "Introducing new AI features in our product suite!",
      likes: 32,
      comments: [{ user: "Daniel", text: "This is a game changer!" }],
    },
  ];

  const toggleComments = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  const handleCommentChange = (id, value) => {
    setNewComments({ ...newComments, [id]: value });
  };

  const addComment = (id) => {
    if (!newComments[id]) return;
    const updatedAnnouncements = announcements.map((ann) =>
      ann.id === id
        ? {
            ...ann,
            comments: [...ann.comments, { user: "You", text: newComments[id] }],
          }
        : ann
    );
    setNewComments({ ...newComments, [id]: "" });
  };

  const sectionRefs = {
    about: useRef(null),
    servicesProviding: useRef(null),
    servicesSeeking: useRef(null),
    products: useRef(null),
    portfolio: useRef(null),
    awards: useRef(null),
    reviews: useRef(null),
    announcement: useRef(null),
    contact: useRef(null),
  };

  const scrollToSection = (ref) => {
    if (ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop - 80,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    let sectionInView = "";
    const subHeader = document.querySelector(".sub-header-profile");

    Object.entries(sectionRefs).forEach(([name, ref]) => {
      const el = ref.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        if (
          rect.top <= window.innerHeight * 0.4 &&
          rect.bottom >= window.innerHeight * 0.2
        ) {
          sectionInView = name;
        }
      }
    });

    if (sectionInView && sectionInView !== activeSection) {
      setActiveSection(sectionInView);
    }

    if (subHeader) {
      const offset = subHeader.offsetTop;
      if (window.scrollY > offset) {
        subHeader.classList.add("fixed-sub-header");
      } else {
        subHeader.classList.remove("fixed-sub-header");
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSection]);








  const [showCanvas, setShowCanvas] = useState(false);
  const handleShow = () => setShowCanvas(true);
  const handleClose = () => setShowCanvas(false);

  const [formData, setFormData] = useState({
    company: "",
    description: "",
    services: [],
    rating: 0
  });


  const serviceOptions = ["Cloud Services", "DevOps Services", "Managed IT Services"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleServiceSelect = (service) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.includes(service)
        ? prev.services.filter(s => s !== service)
        : [...prev.services, service]
    }));
  };

  const handleRating = (index) => {
    setFormData({ ...formData, rating: index + 1 });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Review Submitted:", formData);
  };












  const [showCanvas2, setShowCanvas2] = useState(false);
  const handleShow2 = () => setShowCanvas2(true);
  const handleClose2 = () => setShowCanvas2(false);


  const [step, setStep] = useState(1);
  const [formData2, setFormData2] = useState({
    projectTitle: "",
    projectDescription: "",
    startDate: "",
    budget: "",
    company: "",
    contactName: "",
    email: "",
    phone: "",
    projectType: ""
  });
  const [errors, setErrors] = useState({});

  const projectTypes = ["Web Development", "Mobile App Development", "SEO", "Graphic Design"];

  // useEffect(() => {
  //   setShowCanvas(true);
  // }, []);


  const validate = () => {
    let newErrors = {};
    if (!formData2.projectType) newErrors.projectType = "Project type is required";
    if (!formData2.projectTitle) newErrors.projectTitle = "Project title is required";
    if (!formData2.projectDescription) newErrors.projectDescription = "Project description is required";
    if (!formData2.startDate) newErrors.startDate = "Start date is required";
    if (!formData2.budget) newErrors.budget = "Budget is required";
    if (!formData2.company) newErrors.company = "Company is required";
    if (!formData2.contactName) newErrors.contactName = "Contact name is required";
    if (!formData2.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData2.email)) newErrors.email = "Invalid email format";
    if (!formData2.phone) newErrors.phone = "Phone number is required";


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const nextStep = () => {
    setStep((prevStep) => prevStep + 1);
  };



  const prevStep = () => setStep(step - 1);

  const handleChange2 = (e) => {
    setFormData2({ ...formData2, [e.target.name]: e.target.value });
  };











  return (
    <div>

<div className="sub-header sub-search py-3 bg-light border-bottom border-top">
      <Container>
        <Row className="align-items-start">
          <Col md={12}>
            <Form className="d-flex">
              <Form.Control
                type="search"
                placeholder="e.g. App Development, UX Design, IT Services..."
                className="me-4 px-4 rounded-5"
                aria-label="Search"
              />
              <Form.Control
                type="text"
                placeholder="Enter location"
                className="me-4 px-4 rounded-5"
                aria-label="Location"
              />
              <Button variant="primary" className="px-4 rounded-5">Search</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>





    <section className="page-header bg-skyblue py-2">
  <div className="container pt-4 pb-2">
    <div className="row page-introduction">
      <div className="col-12">
        {/* Breadcrumb and Buttons */}
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
          <div className="w-100 w-md-auto">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item small">
                  <a href="#">Home</a>
                </li>
                <li className="breadcrumb-item small">
                  <a href="#">Companies</a>
                </li>
                <li className="breadcrumb-item small active" aria-current="page">
                  Veritis Group Inc
                </li>
              </ol>
            </nav>
          </div>

          <div className="d-flex flex-column flex-md-row w-100 w-md-auto text-center text-md-end mt-2 mt-md-0">
            <Button
              className="btn btn-md btn-primary py-2 p-3 me-md-3 w-100 w-md-auto mb-2 mb-md-0"
              onClick={() => setShowCanvas2(true)}
            >
              Hire Us
            </Button>
            <button className="btn btn-outline-primary py-2 p-3 me-md-3 text-primary w-100 w-md-auto mb-2 mb-md-0">
              <i className="bx text-primary bx-buildings"></i> Claim This Profile
            </button>
            <button className="btn btn-outline-primary py-2 p-3 text-primary w-100 w-md-auto">
              Visit Website <i className="bx text-primary bx-link-external"></i>
            </button>
          </div>
        </div>

        {/* Company Name, Rating, and Actions */}
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mt-3">
          <div className="text-start text-md-start w-100">
            <h3 className="mt-4">
              Veritis Group Inc
              <span className="ms-3 small verify py-1 rounded-4 fs-6 p-2 text-success">
                <i className="bx text-success bxs-check-circle"></i> Verified
              </span>
            </h3>
            <div className="d-flex align-items-center">
              <button className="btn fs-2 p-0 m-0 pt-0 me-3 icon-clr">
                <i className="bx bx-bookmark"></i>
              </button>
              <button className="btn fs-2 p-0 m-0 pt-0 me-3 icon-clr">
                <i className="bx bxs-check-shield"></i>
              </button>
              <span className="card-text rating">
                <strong className="me-2"> 4.5</strong>
                <i className="bx bxs-star text-warning"></i>
                <i className="bx bxs-star text-warning"></i>
                <i className="bx bxs-star text-warning"></i>
                <i className="bx bxs-star text-warning"></i>
                <i className="bx bxs-star text-warning"></i>
                <span className="ms-3 small">(26 Reviews)</span>
              </span>
            </div>
          </div>

          <div className="text-center text-md-end mt-3 mt-md-0 w-100 w-md-auto d-flex">
            <button
              className="btn btn-link bg-white border-white text-decoration-none py-2 p-3 text-primary w-md-auto mb-2 mb-md-0 me-3"
              onClick={() => setShowCanvas(true)}
            >
              <i className="bx me-1 text-primary bx-edit-alt"></i> Write a Review
            </button>
            <button className="btn btn-danger py-2 p-3 text-white w-md-auto">
              <i className="bx bxs-heart me-1 text-white"></i> Follow
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>






      


      <div className="js-pg-hg-detailed pb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">

              <div className="card border mt-4 rounded-4">
                <div className="brand-img">
                  <img
                    src={veritis_banner}
                    className="card-img-top mx-auto"
                    alt="Veritis Banner"
                  />
                  <div className="brand-logo shadow-sm p-4">
                    <img
                      src={veritis_img}
                      className="card-img-top mx-auto"
                      alt="Veritis Logo"
                    />
                  </div>
                </div>





                <div className="sub-header-profile shadow-sm py-3 px-3 d-none d-md-block">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="profile-menu nav justify-content-center">
          {Object.keys(sectionRefs).map((key) => {
            // Insert a space before capital letters (except the first one)
            const formattedKey = key.replace(/([A-Z])/g, " $1").trim();

            return (
              <div className="nav-item" key={key}>
                <a
                  href={`#${key}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(sectionRefs[key]);
                  }}
                  className={`text-dark nav-link ${activeSection === key ? "active" : ""}`}
                >
                  {formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1)}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </div>
</div>






                {/* Content Sections */}
                <section ref={sectionRefs.about} id="about" className="py-4">

                <div class="card-body px-5 brand-body">
                </div>


                  <div className="row">
                    <div className="col-sm-8">
                      <div class="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex justify-content-between">
                          <div>
                            <h3 class="card-title">Veritis</h3>
                            <p class="card-text lead fs-5 fw-500 text-muted">
                              Irving, United State
                            </p>

                            <p class="card-text fw-500 text-muted">
                              US-based IT Services Provider: Cloud, DevOps, Digital
                              Transformation, Identity Management, and Artificial
                              Intelligence!
                            </p>

                            <p class="card-text text-muted">

                              Veritis is a leading IT consulting service and solution provider. They design, develop, and implement mission-critical solutions that help clients achieve strategic objectives. Their solutions address clients' unique challenges, leveraging Veritis' vast experience in IT consulting. The company delivers results-driven solutions for success, with expertise that enables businesses to thrive. Their team provides personalized support and guidance, driving digital transformation for clients. By staying at the forefront of technology, Veritis helps clients stay ahead of the competition. With a proven track record of success, Veritis is a trusted partner for businesses seeking to achieve their goals through technology.
                            </p>
                          </div>


                        </div>



                      </div>
                    </div>


                    <div className="col-sm-4">
                     <div class="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">
                      <div class="text-muted py-4">
                        <h5 className="border-bottom pb-3">Comany Info</h5>
                        <ul class="list-group-info">
                          <li class="list-group-info py-2">
                            <i class="bx bxs-flag me-1"></i> Founded in 2004
                          </li>
                          <li class="list-group-info py-2">
                            <i class="bx bxs-group me-1"></i> 100 - 150 people
                            in their team
                          </li>
                          <li class="list-group-info py-2">
                            <i class="bx bx-globe me-1"></i> English, Spanish
                          </li>
                          <li class="list-group-info py-2">
                            <i class="bx bx-badge-check me-1"></i> Member Since
                            2025
                          </li>
                        </ul>
                      </div>

                      <div class="text-muted py-4">
                        <h5 className="border-bottom pb-3">Contact Info</h5>
                        <ul class="list-group-info">
                          <li class="list-group-info py-2">
                            <i class="bx bxs-envelope me-1"></i>{" "}
                            info@veritis.com
                          </li>
                          <li class="list-group-info  py-2">
                            <i class="bx bxs-phone me-1"></i> +1 123-456-7890
                          </li>
                        </ul>
                      </div>
                    </div>
                    </div>
                  </div>
                </section>








                <section
                  ref={sectionRefs.servicesProviding}
                  id="services"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Services</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-4">8 services offered by Veritis</p>
                          </div>

                        </div>


                        <div className="d-flex mt-4 flex-wrap">
                          <div className="card py-3 me-3 p-4 mb-4 border">
                            <h5>Cloud Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.5)
                            </p>
                            <small className="text-muted">
                              Skills: AWS, Azure, GCP, Hybrid Cloud
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Containerization Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i> (5.0)
                            </p>
                            <small className="text-muted">
                              Skills: Docker, Kubernetes, OpenShift
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>DevOps Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.7)
                            </p>
                            <small className="text-muted">
                              Skills: CI/CD, Jenkins, GitOps, Terraform
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Digital Transformation Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.6)
                            </p>
                            <small className="text-muted">
                              Skills: AI/ML, RPA, Business Automation
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>
                              Identity and Access Management (IAM) Services
                            </h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i> (5.0)
                            </p>
                            <small className="text-muted">
                              Skills: Okta, AWS IAM, Azure AD, SSO
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed Infrastructure Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.5)
                            </p>
                            <small className="text-muted">
                              Skills: Server Management, Networking, ITSM
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed IT Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i> (5.0)
                            </p>
                            <small className="text-muted">
                              Skills: IT Support, Help Desk, Cloud Operations
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>















                <section
                  ref={sectionRefs.servicesSeeking}
                  id="services"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Services Seeking</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-4">8 services looking by Veritis</p>
                          </div>


                        </div>


                        <div className="d-flex mt-4 flex-wrap">
                          <div className="card py-3 me-3 p-4 mb-4 border">
                            <h5>Architecture Services</h5>
                            <small className="text-muted">
                              Skills: AWS, Azure, GCP, Hybrid Cloud
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Configuration Services</h5>
                            <small className="text-muted">
                              Skills: Docker, Kubernetes, OpenShift
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Data Handling</h5>
                            <small className="text-muted">
                              Skills: CI/CD, Jenkins, GitOps, Terraform
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>AI Transformation Services</h5>
                            <small className="text-muted">
                              Skills: AI/ML, RPA, Business Automation
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>
                              System Security Services
                            </h5>
                            <small className="text-muted">
                              Skills: Okta, AWS IAM, Azure AD, SSO
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed Infrastructure Services</h5>
                            <small className="text-muted">
                              Skills: Server Management, Networking, ITSM
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed IT Services</h5>
                            <small className="text-muted">
                              Skills: IT Support, Help Desk, Cloud Operations
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>












                <section
                  ref={sectionRefs.products}
                  id="products"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex flex-column flex-md-row justify-content-start align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Products</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-4">
                              Our product suite includes custom software solutions and operations.
                            </p>
                          </div>


                        </div>










                        <div className="col-md-12 col-sm-12 mb-4">
  <div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
    {/* Stack for mobile, row for larger screens */}
    <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start">
      <img
        src="https://cdn.iconscout.com/icon/free/png-256/free-jira-software-logo-icon-download-in-svg-png-gif-file-formats--brand-logos-company-pack-icons-7417030.png"
        alt=""
        className="mb-3 mb-md-0 me-md-3 border rounded p-3"
        width="100"
        height="100"
      />
      <div className="ps-md-2 w-100">
        {/* Stack title & icons for mobile */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start">
          <h5 className="mb-1">
            <NavLink to="/" className="text-black text-decoration-none">
              Sage 50 Accounting
            </NavLink>
          </h5>
        </div>

        <p className="text-muted pt-2 mb-4">
          Sage 50 Accounting is a desktop accounting software that helps small
          businesses manage their finances. It offers many features, including
          invoicing, bill pay, expense tracking, inventory management, and
          reporting. Sage 50 Accounting ...
        </p>

        {/* Stack for mobile, row for larger screens */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start border-top pt-3 num-stat mt-3 w-100 gap-3">
          <div className="text-center text-md-start">
            <span className="text-muted">Starting Price</span> <br />
            <strong>$2.98 Per Month</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Free Trial</span> <br />
            <strong>30 Days</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Rating</span> <br />
            <strong>
              4.5{" "}
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bx-star"></i>
            </strong>
          </div>
          {/* Stack buttons for mobile, row for larger screens */}
          <div className="text-center text-md-start">
            <a
              href="/ProductDetailedPage"
              className="btn btn-sm py-2 px-3 btn-outline-primary text-primary me-2"
            >
              View Product
            </a>
            <a href="#" className="btn py-2 btn-primary px-3 btn-sm text-white">
              Visit Website
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>










<div className="col-md-12 col-sm-12 mb-4">
  <div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
    {/* Stack for mobile, row for larger screens */}
    <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start">
      <img
        src="https://www.priority-software.com/wp-content/uploads/2023/06/cropped-fav.png"
        alt=""
        className="mb-3 mb-md-0 me-md-3 border rounded p-3"
        width="100"
        height="100"
      />
      <div className="ps-md-2 w-100">
        {/* Stack title & icons for mobile */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start">
          <h5 className="mb-1">
            <NavLink to="/" className="text-black text-decoration-none">
              Sage 50 Accounting
            </NavLink>
          </h5>

        </div>

        <p className="text-muted pt-2 mb-4">
          Sage 50 Accounting is a desktop accounting software that helps small
          businesses manage their finances. It offers many features, including
          invoicing, bill pay, expense tracking, inventory management, and
          reporting. Sage 50 Accounting ...
        </p>

        {/* Stack for mobile, row for larger screens */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start border-top pt-3 num-stat mt-3 w-100 gap-3">
          <div className="text-center text-md-start">
            <span className="text-muted">Starting Price</span> <br />
            <strong>$2.98 Per Month</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Free Trial</span> <br />
            <strong>30 Days</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Rating</span> <br />
            <strong>
              4.5{" "}
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bx-star"></i>
            </strong>
          </div>
          {/* Stack buttons for mobile, row for larger screens */}
          <div className="text-center text-md-start">
            <a
              href="/ProductDetailedPage"
              className="btn btn-sm py-2 px-3 btn-outline-primary text-primary me-2"
            >
              View Product
            </a>
            <a href="#" className="btn py-2 btn-primary px-3 btn-sm text-white">
              Visit Website
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




                      </div>
                    </div>
                  </div>
                </section>










                <section
                  ref={sectionRefs.portfolio}
                  id="portfolio"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Portfolio</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
                              Our portfolio showcases successful projects across
                              multiple industries.
                            </p>
                          </div>

                        </div>


                        <div className="row">
                          {[...Array(4)].map((_, index) => (
                            <div className="col-md-6 mb-4" key={index}>



<div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
  <div className="d-flex flex-wrap align-items-center">
    {/* Portfolio Image */}
    <img
      src="https://seeklogo.com/images/I/intel-new-2020-logo-21ED2748DD-seeklogo.com.png"
      alt="Portfolio"
      className="border rounded p-3 me-3 img-fluid"
      width="100"
      height="100"
      style={{ maxWidth: "100px" }}
    />

    <div className="ps-0 flex-grow-1 w-100">
      {/* Portfolio Title */}
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-3">
        <h5 className="mb-1 text-truncate">
          <NavLink to="/" className="text-black text-decoration-none">
            Intel Design Portfolio
          </NavLink>
        </h5>
      </div>

      {/* Attached Document + Button */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-1">
        {/* Attached Document */}
        <div className="d-flex align-items-center w-100">
          <i className="bx bx-file me-2 text-primary"></i>
          <span className="text-muted text-truncate w-100">
            Portfolio_Document.pdf
          </span>
        </div>
      </div>

      {/* View Portfolio Button */}
      <a href="#" className="btn btn-sm btn-outline-primary text-primary px-3 mt-3">
        View
      </a>
    </div>
  </div>
</div>




                            </div>
                          ))}
                        </div>{" "}
                        {/* End of Portfolio Grid */}
                      </div>
                    </div>
                  </div>
                </section>








                <section
                  ref={sectionRefs.awards}
                  id="awards"
                  className="py-4 border-top"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">


                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                            <div className="text-center text-md-start">
                              <h3 className="card-title">Awards & Recognitions</h3>
                              <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
                                Recognized for excellence in IT services,
                                innovation, and customer satisfaction.
                              </p>
                            </div>
                          </div>


                          {/* Horizontal Scroll Wrapper */}
                          <div className="horizontal-scroll">
                            {[
                              {
                                name: "Best Innovation Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2023/06/2022-stevie.png",
                                date: "2023",
                              },
                              {
                                name: "Tech Excellence Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2023/09/globee_slider-304.png",
                                date: "2022",
                              },
                              {
                                name: "Customer Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2023/06/2023-stevie.png",
                                date: "2021",
                              },
                              {
                                name: "Cloud Innovation Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2024/05/great-place-work.png",
                                date: "2020",
                              },
                              {
                                name: "AI Excellence Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2024/08/steve-2024-299x300-1.png",
                                date: "2019",
                              },
                              {
                                name: "Industry Leader Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2024/03/Certification-of-Greath-Place-to-work.png",
                                date: "2018",
                              },
                            ].map((award, index) => (
                              <div key={index} className="mx-2">
                                <div
                                  className="card shadow-sm rounded-4 h-100 d-flex flex-column card-hover"
                                  style={{ width: "250px" }}
                                >
                                  <div className="text-center">
                                    <img
                                      src={award.image}
                                      alt={award.name}
                                      className="border-none rounded-top-4"
                                      style={{ height: "auto", width: "150px" }}
                                    />
                                  </div>

                                  <div className="mt-3 text-center p-3">
                                    <h5 className="mb-1">{award.name}</h5>
                                    <span className="text-muted small badge p-2 mt-3">
                                      {award.date}
                                    </span>

                                  </div>

                                </div>
                              </div>
                            ))}
                          </div>{" "}
                          {/* End of Scrollable Section */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>









                <section
                  ref={sectionRefs.reviews}
                  id="reviews"
                  className="py-4 border-top"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                           <div className="text-center text-md-start">
                          <h3 className="card-title">Reviews</h3>
                          <p className="card-text lead fs-6 fw-500 text-muted pb-4">
                            Our clients praise our commitment to quality,
                            innovation, and customer service excellence.
                          </p>
                          {/* Horizontal Scroll Wrapper */}
                          <div className="horizontal-scroll">
                            {[
                              {
                                name: "John Doe",
                                date: "March 5, 2024",
                                rating: 5,
                                feedback:
                                  "Excellent service! Highly professional and exceeded expectations.",
                              },
                              {
                                name: "Emily Smith",
                                date: "February 22, 2024",
                                rating: 4,
                                feedback:
                                  "Great experience! The team was responsive and delivered on time.",
                              },
                              {
                                name: "Michael Brown",
                                date: "January 30, 2024",
                                rating: 5,
                                feedback:
                                  "Fantastic support and outstanding quality of work! Thank you so much...",
                              },
                              {
                                name: "Sarah Wilson",
                                date: "December 18, 2023",
                                rating: 4,
                                feedback:
                                  "Very happy with the results. Just a few minor improvements needed.",
                              },
                              {
                                name: "David Johnson",
                                date: "November 10, 2023",
                                rating: 5,
                                feedback:
                                  "Top-notch service! Will definitely work with them again I'm very happy.",
                              },
                              {
                                name: "Olivia Martinez",
                                date: "October 5, 2023",
                                rating: 3,
                                feedback:
                                  "Decent service, but the response time could be improved.",
                              },
                            ].map((review, index) => (
                              <div key={index} className="review-card">
                                <div className="card mx-2 p-4 shadow-sm ls-profile rounded-4 review-card-height">
                                  {/* User Profile Icon - Moved Above Name */}
                                  <div className="text-center">
                                    <img
                                      src="https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                      alt="User"
                                      className="border rounded-circle p-2 mb-3"
                                      width="60"
                                      height="60"
                                    />
                                  </div>

                                  {/* User Details */}
                                  <div className="text-center">
                                    <h5 className="mb-1">{review.name}</h5>
                                    <span className="text-muted small">
                                      {review.date}
                                    </span>
                                  </div>

                                  {/* Star Rating */}
                                  <div className="text-center mt-2 text-warning">
                                    {"★".repeat(review.rating)}
                                    {"☆".repeat(5 - review.rating)}
                                  </div>

                                  {/* User Feedback */}
                                  <p className="mt-3 text-muted text-center">
                                    {review.feedback}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>{" "}
                          {/* End of Scrollable Section */}
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </section>






















                <section id="announcement" className="py-4 border-top">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
  <div className="text-center text-md-start">
    <h3 className="card-title">Announcements</h3>
    <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
      Stay updated with the latest company news, events, and updates.
    </p>
  </div>
</div>






                          {/* Announcement Cards */}
                          <div className="row">
                            {announcements.map((ann) => (
                              <div className="col-md-12 col-12" key={ann.id}>



<div className="card mx-2 p-4 mb-4 shadow-sm rounded-4 card-hover">
  <div className="d-flex justify-content-between align-items-center flex-column flex-md-row text-center text-md-start">
    <h5 className="mb-2 mb-md-1">{ann.title}</h5>
  </div>

  <span className="text-muted small">{ann.date}</span>
  <p className="mt-3">{ann.description}</p>

  {/* Reactions Section */}
  <div className="d-flex justify-content-between align-items-center flex-column flex-md-row text-center text-md-start">
    <span className="text-muted mb-2 mb-md-0">
      👍 {ann.likes} Likes &nbsp; 💬 {ann.comments.length} Comments
    </span>
    <button className="btn btn-sm btn-outline-primary text-primary" onClick={() => toggleComments(ann.id)}>
      {expanded === ann.id ? "Hide Comments" : "View Comments"}
    </button>
  </div>

  {/* Comments Section */}
  {expanded === ann.id && (
    <div className="mt-3">
      <ul className="list-unstyled">
        {ann.comments.map((comment, index) => (
          <li key={index} className="border-bottom py-2">
            <div className="d-flex align-items-start flex-column flex-md-row text-center text-md-start">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Tesla_logo.png/1024px-Tesla_logo.png"
                alt="User"
                className="border rounded-circle p-1 mb-2 mb-md-0 me-md-2"
                width="40"
                height="40"
              />
              <div>
                <strong>{comment.user}</strong>
                <span className="text-muted small d-block">{comment.timestamp}</span>
                <p className="mb-0">{comment.text}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>

      {/* Write Comment Section */}
      <div className="input-group mt-2">
        <input
          type="text"
          className="form-control"
          placeholder="Write a comment..."
          value={newComments[ann.id] || ""}
          onChange={(e) => handleCommentChange(ann.id, e.target.value)}
        />
        <button className="btn btn-primary" onClick={() => addComment(ann.id)}>
          Send
        </button>
      </div>
    </div>
  )}
</div>




                              </div>
                            ))}
                          </div> {/* End of Announcement Grid */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>






















                <section
                  ref={sectionRefs.contact}
                  id="contact"
                  className="py-4 border-top"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                            <div className="text-center text-md-start">
                              <h3 className="card-title">Our Branches</h3>
                              <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
                                Find our offices worldwide. Connect with our branch collaborations.
                              </p>
                            </div>
                          </div>




                          <div className="row">
                            {[
                              {
                                country: "USA",
                                city: "New York",
                                address: "123 5th Ave, New York, NY 10001, USA",
                                logo: "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
                              },
                              {
                                country: "UK",
                                city: "London",
                                address: "456 Oxford St, London W1D 1AN, UK",
                                logo: "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
                              },
                              {
                                country: "India",
                                city: "Bangalore",
                                address:
                                  "789 MG Road, Bangalore, Karnataka 560001, India",
                                logo: "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
                              },
                            ].map((branch, index) => (
                              <div className="col-md-6 mb-4" key={index}>




<div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
  <div className="d-flex align-items-center flex-column flex-md-row text-center text-md-start">
    {/* Branch Logo */}
    <img
      src={branch.logo}
      alt="Branch Logo"
      className="border rounded p-3 mb-3 mb-md-0 me-md-3"
      width="100"
      height="100"
    />

    <div className="ps-md-2 w-100">
      {/* Branch Info */}
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row text-center text-md-start">
        <h5 className="mb-2 mb-md-3 text-black">{branch.city}, {branch.country}</h5>
      </div>

      <p className="text-muted mb-1">{branch.address}</p>
      <p className="fw-600 text-primary">Get Location Map</p>
    </div>
  </div>
</div>




                              </div>
                            ))}
                          </div>{" "}
                          {/* End of Branch Grid */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>







              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />







      <Offcanvas show={showCanvas} onHide={handleClose} placement="end" style={{ width: 680 }}>
        <Offcanvas.Header closeButton className="px-5 py-4 bg-skyblue">
          <Offcanvas.Title>Write a Review</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="px-5 bg-light">
          <Container>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mt-4">
                <Form.Label>Select Services</Form.Label>
                <div>
                  {serviceOptions.map(service => (
                    <Badge key={service} pill bg={formData.services.includes(service) ? "primary" : "secondary"} className="me-2 px-3 pr-btn border-0 text-white cursor-pointer"
                      onClick={() => handleServiceSelect(service)}
                    >
                      {service}
                    </Badge>
                  ))}
                </div>
              </Form.Group>

              <Form.Group className="mt-4">
                <Form.Label>Can you write your review feedback</Form.Label>
                <Form.Control as="textarea" name="description" rows={3} value={formData.description} onChange={handleChange} required />
              </Form.Group>

              <Form.Group className="mt-4">
                <Form.Label className="m-0 p-0">Rate</Form.Label>
                <div>
                  {[...Array(5)].map((_, index) => (
                    <span key={index} onClick={() => handleRating(index)} style={{ cursor: "pointer", fontSize: "1.5rem", marginRight: "5px" }}>
                      {index < formData.rating ? <FaStar className="text-warning" /> : <FaRegStar className="text-warning" />}
                    </span>
                  ))}
                </div>
              </Form.Group>

              <Button variant="primary" type="submit" className="btn-lg mt-3" as={Link} to="/MyReviews">Submit Review</Button>
            </Form>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>



















      <Offcanvas 
  show={showCanvas2} 
  onHide={handleClose2} 
  placement="end" 
  style={{ width: 600 }}
>
  <Offcanvas.Header closeButton className="px-5 pt-4">
    <Offcanvas.Title>Hire Us</Offcanvas.Title>
  </Offcanvas.Header>
  <Offcanvas.Body className="px-5">
    <div className="d-flex align-items-center p-3 border bg-light rounded-4">
      <img
        src="https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4"
        alt="Veritis Development Agency"
        className="img-thumbnail rounded-3 border me-3"
        style={{ maxWidth: "80px" }}
      />
      <div>
        negozio <h5 className="card-title pb-2" style={{ cursor: "pointer" }}>
          Veritis Development Agency
        </h5>
        <span className="card-text">
          <strong className="me-2">4.5</strong>
          {[...Array(5)].map((_, index) =>
            index < 5 ? (
              <FaStar key={index} className="text-warning" />
            ) : (
              <FaRegStar key={index} className="text-warning" />
            )
          )}
          <span className="ms-2 small">(26 Reviews)</span>
        </span>
      </div>
    </div>

    <div className="pt-2">
      <div className="d-flex align-items-center justify-content-between mb-4 position-relative border rounded-3 p-3 mt-4">
        {["Project Info", "Contact Info", "Preview"].map((stepTitle, index) => (
          <div key={index} className="position-relative d-flex flex-column align-items-center flex-grow-1">
            {index !== 0 && (
              <div 
                className="position-absolute top-50 start-0 w-100 border-bottom border-dashed border-secondary"
                style={{ left: '50%', transform: 'translateX(-50%)', zIndex: -1 }}
              ></div>
            )}
            <div className={`badge d-flex fs-6 align-items-center p-2 px-3
              ${step > index + 1 ? 'bg-success text-white' : step === index + 1 ? 'border-primary bg-white text-primary' : 'bg-light text-dark'}`}>
              {stepTitle}
            </div>
          </div>
        ))}
      </div>

      {/* Step 1: Project Information */}
      {step === 1 && (
        <>
          <h5 className="py-3">Project Information</h5>
          <Form>
            <Form.Group className="mb-4">
              <Form.Label>Project Type</Form.Label>
              <Form.Select name="projectType" value={formData2.projectType} onChange={handleChange2}>
                <option value="">Select Project Type</option>
                {projectTypes.map((type, index) => (
                  <option key={index} value={type}>{type}</option>
                ))}
              </Form.Select>
              {errors.projectType && <div className="text-danger">{errors.projectType}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Project Title</Form.Label>
              <Form.Control type="text" name="projectTitle" value={formData2.projectTitle} onChange={handleChange2} />
              {errors.projectTitle && <div className="text-danger">{errors.projectTitle}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Project Description</Form.Label>
              <Form.Control as="textarea" rows={3} name="projectDescription" value={formData2.projectDescription} onChange={handleChange2} />
              {errors.projectDescription && <div className="text-danger">{errors.projectDescription}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Start From</Form.Label>
              <Form.Select name="startDate" value={formData2.startDate} onChange={handleChange2}>
                <option value="">Select Start Time</option>
                <option value="immediately">Immediately</option>
                <option value="lessThan15">Less than 15 Days</option>
                <option value="15to30">15-30 Days</option>
                <option value="30to60">30-60 Days</option>
              </Form.Select>
              {errors.startDate && <div className="text-danger">{errors.startDate}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Budget</Form.Label>
              <Form.Select name="budget" value={formData2.budget} onChange={handleChange2}>
                <option value="">Select Budget</option>
                <option value="$10,000-20,000">$10,000-20,000</option>
                <option value="$20,000-40,000">$20,000-40,000</option>
                <option value="$40,000-60,000">$40,000-60,000</option>
              </Form.Select>
              {errors.budget && <div className="text-danger">{errors.budget}</div>}
            </Form.Group>

            <Button className="btn btn-primary mt-2" onClick={nextStep}>Continue</Button>
          </Form>
        </>
      )}

      {/* Step 2: Timeline & Contacts */}
      {step === 2 && (
        <>
          <h5 className="py-3">Your Information</h5>
          <Form>
            <Form.Group className="mb-4">
              <Form.Label>Company Name</Form.Label>
              <Form.Control type="text" name="company" value={formData2.company} onChange={handleChange2} />
              {errors.company && <div className="text-danger">{errors.company}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Your Full Name</Form.Label>
              <Form.Control type="text" name="contactName" value={formData2.contactName} onChange={handleChange2} />
              {errors.contactName && <div className="text-danger">{errors.contactName}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Email Address</Form.Label>
              <Form.Control type="email" name="email" value={formData2.email} onChange={handleChange2} />
              {errors.email && <div className="text-danger">{errors.email}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Phone</Form.Label>
              <Form.Control type="text" name="phone" value={formData2.phone} onChange={handleChange2} />
              {errors.phone && <div className="text-danger">{errors.phone}</div>}
            </Form.Group>

            <Button className="btn btn-outline-primary text-primary me-3" onClick={prevStep}>Back</Button>
            <Button className="btn btn-primary" onClick={nextStep}>Continue</Button>
          </Form>
        </>
      )}

      {/* Step 3: Preview */}
      {step === 3 && (
        <>
          <h5 className="py-3">Review & Submit</h5>
          {Object.entries(formData2).map(([key, value]) => (
            <p key={key} className="pt-2 pb-3 m-0 mb-2 border-bottom">
              <span className="text-muted small d-block">
                {key.replace(/([A-Z])/g, " $1").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}:
              </span>
              <span className="d-block fs-6 pt-2">{value}</span>
            </p>
          ))}
          <Button className="btn btn-outline-primary mt-3 text-primary me-3" onClick={prevStep}>Back</Button>
          <Button className="btn btn-primary mt-3" onClick={nextStep}>Submit</Button>
        </>
      )}

      {/* Step 4: Submitted */}
      {step === 4 && (
        <>
          <div className="text-center border rounded-4 p-5">
            <h3 className="mb-4">Congratulations! 🎉</h3>
            <p>Your request has been successfully submitted as a proposal.</p>
            <Button className="btn btn-outline-primary mt-3 text-primary me-3" onClick={handleClose2}>Close</Button>
            <Button className="btn btn-primary mt-3" as={Link} to="/noncompanyprofile">View Proposals</Button>
          </div>
        </>
      )}
    </div>
  </Offcanvas.Body>
</Offcanvas>








    </div>
  );
};

export default CompanyProfile;
